import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { Dynamic } from '@shared/registry/dynamic';

import { type StepOverviewCardGroupConfig } from './step-overview-card.types';

@Component({
  selector: 'app-step-overview-card',
  templateUrl: './step-overview-card.html',
  imports: [Dynamic],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepOverviewCard {
  readonly config = input.required<StepOverviewCardGroupConfig>();

  protected readonly hasBorder = computed(() => this.config().hasBorder ?? false);

  protected readonly stepConfigs = computed(() =>
    this.config().steps.map((step) => ({
      step,
      chipConfig: {
        text: step.stepLabel,
        variant: 'primary' as const,
      },
      textConfig: {
        text: step.text,
        size: 'base' as const,
        fontWeight: 'semibold' as const,
        color: 'var(--stepoverviewcard-text-color)',
        fontFamily: 'var(--stepoverviewcard-font-family)',
      },
    })),
  );
}
